import RewindJob, { RewindJobStatuses } from '../../../../types/api/rewind-job'
import { isRewindJobPaused } from '../../../rewinder-machines-schedule/components/one-rewinder-machine/helpers/rewind-job-helpers'
import { getPrintProgress } from './get-print-progress'

export function getRewindRowClassName(rewindJob?: RewindJob): string {
    const classNames: string[] = []

    if (rewindJob?.jobStatus === RewindJobStatuses.Cancelled)
        classNames.push('rewind-job-cancelled')
    else if (isRewindJobPaused(rewindJob)) classNames.push('rewind-job-paused')

    if (getPrintProgress(rewindJob?.shipment) === 'waiting') classNames.push('rewind-print-waiting')

    return classNames.join(' ')
}
